/* eslint-disable @typescript-eslint/no-empty-function */
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import {
  dateToDateString,
  isMigrateFromElexys
} from "@/app/infrastructures/misc/Utils";
import en from "@/i18n/locales/en";
import id from "@/i18n/locales/id";
import my from "@/i18n/locales/my";
import { createI18n } from "vue-i18n";
import { AccountController } from "@/app/ui/controllers/AccountController";

let doc: any;
let translate: any = () => {};

export const partnerTypes = (type: string) => {
  switch (type) {
    case "console":
      return "Consolidator";
    case "pos":
      return "POS";
    default:
      return "Sub-Consolidator";
  }
};

export const drawCellConditions = (cell: any) => {
  const head = cell.row?.section === "head";
  const body = cell.row?.section === "body";
  return [
    cell.column?.dataKey === "product" && head,
    cell.row?.cells[3].text[0] === "",
    cell.column?.dataKey === "product" && body,
    cell.column?.dataKey === "hanging" && head,
    cell.row?.cells[8].text[0] === "",
    cell.column?.dataKey === "hanging" && body
  ];
};

export const drawCellData = (cell: any) => {
  if (drawCellConditions(cell)[0]) {
    cell.row.cells[3].styles = {
      ...cell.row.cells[3].styles,
      cellPadding: {
        ...cell.row.cells[3].styles.cellPadding,
        left: 0.7
      }
    };
  }
  if (
    drawCellConditions(cell)[1] ||
    drawCellConditions(cell)[4] ||
    cell.row.cells[8].text[0] === ""
  ) {
    Object.keys(cell.row.cells).forEach((key) => {
      Object.keys(cell.row.cells[key].text).forEach((text) => {
        cell.row.cells[key].text[text] =
          cell.row.cells[key].text[parseInt(text) + 1] || "";
      });
    });
  }
  if (drawCellConditions(cell)[2]) {
    doc.setFillColor("#EBECF0");
    cell.row.cells[3].text
      .filter((item: any) => item !== "")
      .map((_: any, index: number) => {
        doc.roundedRect(
          cell.row.cells[3].x + 0.7,
          cell.row.cells[3].y +
            cell.row.cells[3].contentHeight /
              (1.6333 +
                2.5 *
                  cell.row.cells[3].text.filter((item: any) => item !== "")
                    .length) +
            (0.0083 + 5.675 * index),
          cell.row.cells[3].contentWidth - 1,
          4,
          1,
          1,
          "F"
        );
      });
    doc.setFillColor("#fff");
  }
  if (drawCellConditions(cell)[3]) {
    cell.row.cells[8].styles = {
      ...cell.row.cells[8].styles,
      cellPadding: {
        ...cell.row.cells[8].styles.cellPadding,
        left: 0.7
      }
    };
  }
  if (drawCellConditions(cell)[5]) {
    doc.setFillColor("#EBECF0");
    cell.row.cells["hanging"].text
      .filter((item: any) => item !== "")
      .map((_: any, index: number) => {
        doc.roundedRect(
          cell.row.cells["hanging"].x + 0.7,
          cell.row.cells["hanging"].y +
            cell.row.cells["hanging"].contentHeight /
              (1.6333 +
                2.5 *
                  cell.row.cells["hanging"].text.filter(
                    (item: any) => item !== ""
                  ).length) +
            (0.0083 + 5.675 * index),
          cell.row.cells["hanging"].contentWidth - 1,
          4,
          1,
          1,
          "F"
        );
      });
    doc.setFillColor("#fff");
  }
};

const manifestPdf = (
  //   dataHead: BaggingDataDetail,
  dataHead: any,
  data: any,
  logo: string
) => {
  doc = new jsPDF("p", "mm", "a4", true);
  const locale =
    AccountController.accountData.account_type_detail?.countryCode?.toLowerCase() ||
    "id";
  const formatDate = (date: Date) => {
    return `${dateToDateString(new Date(date), false, false, locale)}`;
  };

  const i18nInstance = createI18n({
    legacy: false,
    locale,
    fallbackLocale: "id",
    globalInjection: false,
    messages: {
      en,
      id,
      my
    }
  });
  translate = i18nInstance.global.t;

  const pdfWidth = doc.internal.pageSize.width;
  const logoProperties = doc.getImageProperties(logo);
  const logoAspectRatio = logoProperties.height / logoProperties.width;

  const imageWidth = 40;
  const imageHeight = logoAspectRatio * 40;
  doc.addImage(
    logo,
    "PNG",
    pdfWidth - imageWidth - 9,
    11,
    imageWidth,
    imageHeight,
    "logo",
    "FAST",
    0
  );
  doc.setFont("helvetica", "bold");
  doc.setFontSize(16);
  doc.setTextColor("#4d4d4d");
  doc.text(
    `${translate("cariStt.pdf.title")} - ${dataHead.manifestNo}`,
    10,
    18
  );
  doc.setFillColor("#e0e0e0");
  doc.rect(10, 25, 190, 0.2, "F");
  doc.setFont("helvetica", "normal");
  doc.setFontSize(7);

  // left column
  doc.setTextColor("#4d4d4d");
  doc.setFillColor("#ebecf0");

  //   header column 1
  doc.text(translate("cariStt.pdf.partnerName"), 10, 30);
  doc.text(`: ${dataHead.partnerName}`, 33, 30);

  doc.text(translate("cariStt.pdf.partnerCity"), 10, 35);
  doc.text(
    `: ${dataHead.partnerCity3lc} - ${dataHead.partnerCityName}`,
    33,
    35
  );

  //   header column 2
  doc.text(translate("cariStt.pdf.totalSttKoli"), 80, 30);
  doc.text(`: ${dataHead.totalStt}/${dataHead.totalPieces}`, 110, 30);

  doc.text(translate("cariStt.pdf.totalSttHangingKoli"), 80, 35);
  doc.text(
    `: ${dataHead.totalSttHanging}/${dataHead.totalPiecesHanging}`,
    110,
    35
  );

  //   header column 3
  doc.text(translate("cariStt.pdf.manifestDateHanging"), 140, 30);
  doc.text(`: ${formatDate(dataHead.createdAt)}`, 170, 30);

  doc.text(translate("cariStt.pdf.userManifest"), 140, 35);
  doc.text(`: ${dataHead.createdByUsername}`, 170, 35);

  let lastPage = 0;
  let lastY = 0;
  let lastHeight = 0;
  const dataLength = data.length;
  const columnsTable = () => [
    { header: translate("cariStt.table.no"), dataKey: "no" },
    { header: translate("cariStt.table.noStt"), dataKey: "sttNo" },
    { header: translate("cariStt.pdf.noRef"), dataKey: "noRef" },
    { header: translate("cariStt.pdf.productType"), dataKey: "product" },
    { header: translate("cariStt.pdf.lastStatus"), dataKey: "lastStatus" },
    { header: translate("cariStt.pdf.hanging"), dataKey: "hanging" },
    { header: translate("cariStt.pdf.hangingType"), dataKey: "hangingType" },
    { header: translate("cariStt.pdf.originCity"), dataKey: "originCity" },
    { header: translate("cariStt.pdf.destCity"), dataKey: "destCity" }
  ];
  const columnStyles = {
    0: { cellWidth: 10 },
    1: { cellWidth: 28 },
    2: { cellWidth: 28 },
    3: { cellWidth: 28 },
    4: { cellWidth: 18 },
    5: { cellWidth: 18 },
    6: { cellWidth: 24 },
    7: { cellWidth: 18 },
    8: { cellWidth: 18 }
  };
  !isMigrateFromElexys() && columnsTable().splice(1, 1);
  doc.autoTable({
    body: data,
    columns: columnsTable(),
    theme: "plain",
    startY: doc.internal.getCurrentPageInfo().pageNumber === 1 ? 40 : 0,
    margin: { top: 7, left: 10, right: 10, bottom: 7 },
    headStyles: {
      font: "helvetica",
      fontStyle: "bold",
      fillColor: "#f5f6f7",
      textColor: "#1a1421",
      fontSize: 6,
      halign: "left",
      cellPadding: { top: 4, right: 2, bottom: 4, left: 2 }
    },
    bodyStyles: {
      font: "helvetica",
      fontStyle: "normal",
      fillColor: "#fff",
      textColor: "#1a1421",
      fontSize: 7,
      halign: "left",
      valign: "top",
      lineColor: "#e0e0e0",
      lineWidth: { top: 0.1, right: 0, bottom: 0.1, left: 0 },
      cellPadding: { top: 3, right: 2, bottom: 3, left: 2 },
      cellWidth: "auto"
    },
    columnStyles: columnStyles,
    willDrawCell: (cell: any) => {
      drawCellData(cell);
      lastPage = cell.pageNumber;
      lastY = cell.cursor.y;
      lastHeight = cell.row.height;
      if (cell.row.index === dataLength - 2 && lastY + lastHeight + 20 > 270) {
        cell.cell.contentHeight = 100;
        cell.row.height = 100;
      }
    }
  });
  lastY = lastY + lastHeight + 20;
  lastY = lastY > 270 ? 270 : lastY;
  doc.setPage(lastPage);
  doc.setFontSize(8);
  doc.text(translate("cariStt.pdf.staffAdmin"), 19 + 90, lastY);
  doc.text("(.................................)", 14 + 90, lastY + 20);
  doc.text(translate("cariStt.pdf.courier"), 60 + 90, lastY);
  doc.text("(.................................)", 50 + 90, lastY + 20);
  doc.text(translate("cariStt.pdf.operationsSupervisor"), 84 + 90, lastY);
  doc.text("(.................................)", 84 + 90, lastY + 20);

  doc.setProperties({
    title: `${translate("cariStt.pdf.title")} - ${dataHead.manifestNo}`
  });
  doc.autoPrint();
  window.open(doc.output("bloburl"), "_blank");
};

export default manifestPdf;
